// eslint-disable-next-line import/no-anonymous-default-export
export default {
  l10n: {
    currency: '\u20ac',
    date: {
      months: {
        full: [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ],
        abbr: [
          'jan',
          'feb',
          'mär',
          'apr',
          'mai',
          'jun',
          'jul',
          'aug',
          'sep',
          'okt',
          'nov',
          'dez',
        ],
      },
      days: {
        full: [
          'Sonntag',
          'Montag',
          'Dienstag',
          'Mittwoch',
          'Donnerstag',
          'Freitag',
          'Samstag',
        ],
        abbr: ['son', 'mon', 'die', 'mit', 'don', 'fre', 'sam'],
      },
      patterns: {
        longDate: 'dddd, D. MMMM YYYY',
        dateSlash: 'DD/MM/YYYY',
        dateShort: 'dddd, D. MMMM',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd, D. MMMM - H[:]mm',
        dateMediumReversed: 'H[:]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY [um] H[:]mm',
        dateLarge: 'D MMM YYYY [um] H[:]mm',
        timeShort: 'LT',
        timeMedium: 'DD[/]MM LT',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['-n S', 'n S'],
      },
      group: {
        separator: '.',
        length: 3,
        abbr: ['', 'Tausend', 'Million', 'Billion'],
      },
      decimal: {
        separator: ',',
        length: 2,
      },
      plural: 'nplurals=2; plural=(n != 1);',
      ordinal: function (number) {
        return number + (number === 1 ? 'er' : '.');
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Einkaufswagen'],
      Favourites: [null, 'Favoriten'],
      Delivery: [null, 'Lieferung'],
      Summary: [null, 'Übersicht'],
      Order: [null, 'Bestellung'],
      Categories: [null, 'Kategorien'],
      'No results found': [null, 'Keine Artikel gefunden'],
      'No favourites': [null, 'Keine Favoriten'],
      'Empty cart': [null, 'Einkaufswagen leer'],
      'No order': [null, 'Keine Bestellung'],
      'Add to cart': [null, 'In den Einkaufswagen'],
      Included: [null, 'Inklusive'],
      Delete: [null, 'Entfernen'],
      Items: [null, 'Artikel'],
      Description: [null, 'Beschreibung'],
      Quantity: [null, 'Menge'],
      Price: [null, 'Preis'],
      'Where would you like to receive your order?': [
        null,
        'Wohin soll deine Bestellung geliefert werden?',
      ],
      Address: [null, 'Adresse'],
      'Address details': [null, 'Zusätzliche Adresse'],
      'Estimated delivery date': [null, 'Lieferung voraussichtlich am'],
      'Confirm delivery': [null, 'Bestelleung bestätigen'],
      Form: [null, 'Formular'],
      'Winamax account address': [null, 'Adresse deines Winamax Accounts'],
      'Other address': [null, 'Andere Adresse'],
      'Search an address': [null, 'Finden Sie eine Adresse'],
      'Please select an address in Europe': [
        null,
        'Bitte wählen Sie eine Adresse in Europa aus',
      ],
      'Please complete required fields': [
        null,
        'Bitte füllen Sie die erforderlichen Felder aus',
      ],
      'Enter your personal information': [null, 'Deine persönlichen Daten'],
      'Address 2': [null, 'Adresse 2'],
      Postcode: [null, 'Postleitzahl'],
      City: [null, 'Ort'],
      'Telephone number': [null, 'Telefonnummer'],
      'I agree for my account to be debited': [
        null,
        'Ich stimme zu, dass mein Konto belastet wird',
      ],
      Confirmation: [null, 'Bestätigung'],
      Save: [null, 'Speichern'],
      'View order': [null, 'Die Bestellung ansehen'],
      'Back to the shop': [null, 'Zurück zur Boutique'],
      Orders: [null, 'Bestellungen'],
      Pay: [null, 'Bezahlen'],
      'Thank you': [null, 'Danke'],
      'We have received your order': [
        null,
        'Wir haben Deine Bestellung erhalten',
      ],
      'You will receive a confirmation e-mail shortly': [
        null,
        'Du erhälst eine Bestellbestätigung per E-Mail',
      ],
      'In progress': [null, 'In Bearbeitung'],
      Completed: [null, 'Abgeschlossen'],
      'Order status': [null, 'Status meiner Bestellung'],
      'Contact support': [null, 'Den Support kontaktieren'],
      'Track order': [null, 'Sendung nachverfolgen'],
      'Order date': [null, 'Bestelldatum'],
      'Order number': [null, 'Bestellnummer'],
      Sort: [null, 'Ordnen'],
      Miles: [null, 'Miles'],
      'View results': [null, 'Ergebnisse ansehen'],
      Recommended: [null, 'Empfohlen'],
      'Price ascending': [null, 'Aufsteigende Preise'],
      'Price descending': [null, 'Absteigende Preise'],
      'Show only products I can buy': [
        null,
        'Nur Produkte anzeigen, die ich kaufen kann',
      ],
      Under: [null, 'Weniger als'],
      Over: [null, 'Mehr als'],
      Validate: [null, 'Bestätigen'],
      Cancel: [null, 'Abbrechen'],
      'Confirm cancellation': [null, 'Löschen bestätigen'],
      'Are you sure you want to delete this item?': [
        null,
        'Bist Du sicher, dass Du dieses Produkt entfernen möchtest?',
      ],
      'Product added to favorites': [
        null,
        'Produkt zu den Favoriten hinzugefügt',
      ],
      'Product added to cart': [null, 'Produkt zum Einkaufswagen hinzugefügt'],
      See: [null, 'Ansehen'],
      'PRICE CHANGE': [null, 'PREISÄNDERUNG'],
      'The price of the %1$s product has changed. It will be adjusted in your cart.':
        [
          null,
          'Der Preis des %1$s Produkts hat sich geändert. Anpassung erfolgt.',
        ],
      'QUANTITY UNAVAILABLE': [null, 'ANZAHL NICHT VERFÜGBAR'],
      'We are sorry, the %1$s product is no longer available in the quantity you selected.':
        [
          null,
          'Sorry, das %1$s Produkt ist in der gewünschten Anzahl nicht mehr verfügbar.',
        ],
      'Product unavailable': [null, 'Produkt nicht verfügbar'],
      'We are sorry, the %1$s product is no longer available. It will be removed from your cart.':
        [
          null,
          'Sorry, das %1$s Produkt ist nicht mehr verfügbar. Es wird aus dem Einkaufswagen entfernt.',
        ],
      Phone: [null, 'Telefon'],
      All: [null, 'Alles'],
      Maintenance: [null, 'Instandhaltung'],
      Fitting: [null, 'Fitting'], // This is not translated, as "Fitting" might have different meanings. You might want to provide a context or use a German equivalent based on the context.
      Manufacturer: [null, 'Herstellung'],
      Back: [null, 'Zurück'],

      /// ORDER STATUS
      'Order ready for delivery': [null, 'Bestellung bereit zum Versand'],
      'Order being prepared': [null, 'Bestellung wird bearbeitet'],
      'Order in process': [null, 'Bestellung wird bearbeitet'], // Note: This is the same translation as "Order being prepared"
      'Order being delivered': [null, 'Bestellung wird geliefert'],
      'This order requires some action on your part': [
        null,
        'Bestellung erfordert Ihr Eingreifen',
      ],
      'Order being processed manually': [
        null,
        'Bestellung wird manuell bearbeitet',
      ],
      'Order completed': [null, 'Bestellung abgeschlossen'],
      'Order returned': [null, 'Bestellung zurückgesandt'],
      'Order cancelled': [null, 'Bestellung annuliert'],
      'Order resubmitted': [null, 'Erneute Bestellung'],
      'Order refunded': [null, 'Bestellung zurückerstattet'],

      // CART ERRORS
      IMPORTANT: [null, 'ACHTUNG'],
      'Some products could not be ordered due to %1$s. \n You can find them in your cart.':
        [
          null,
          'Einige Produkte konnten nicht bestellt werden %1$s. \n Sie finden Sie in Ihrem Einkaufswagen.',
        ],
      CONFIRM: [null, 'BESTÄTIGEN'],
      'Unable to order': [null, 'Bestellung unmöglich'],
      'Your order could not be completed because of %1$s': [
        null,
        'Die Bestellung konnte nicht abgeschlossen werden %1$s.',
      ],
      'Your order could not be completed': [
        null,
        'Die Bestellung konnte nicht abgeschlossen werden',
      ],
      'Back to cart': [null, 'Zurück zum Warenkorb'],

      // DEBIT MILES ERRORS
      'an identical order in progress': [
        null,
        'da eine andere, identische Bestellung bereits anhängig ist',
      ],
      'a technical error': [null, 'es ist ein technischer Fehler aufgetreten'],
      'an error in the recipient of the bonus': [
        null,
        'da ein Fehler beim Empfänger des Bonus aufgetreten ist',
      ],
      'an insufficient Miles balance': [
        null,
        'da nicht genug Miles vorhanden sind',
      ],
      'a deposit limit reached on your account': [
        null,
        'ein Einzahlungslimit auf Ihrem Konto erreicht',
      ],
      'You cannot offer this product to this player': [null, 'Das Produkt kann diesem Spieler nicht angeboten werden'],

      // ADDITIONAL TRANSLATIONS
      'Log in to order': [null, 'Anmelden'],
      'Delete all filters': [null, 'Alle Filter zurücksetzen'],
      Materials: [null, 'Materialien'],
      'Next availability': [null, 'Nächste Verfügbarkeit'],
      'All categories': [null, 'Alles sehen'],
      Filters: [null, 'Filter'],
      'See all': [null, 'Alles sehen'],
      'Check Details': [null, 'Details ansehen'],
      'Place Order': [null, 'Befehl'],
      'Enter a nickname': [null, 'Geben Sie einen Benutzernamen ein'],
      'Your order will be shipped in multiple shipments': [
        null,
        'Ihre Bestellung wird in mehreren Sendungen verschickt',
      ],
      Offer: [null, 'Angebot'],
      View: [null, 'Ansehen'],
      'Express order': [null, 'Expresskauf'],
      Buy: [null, 'Kaufen'],
      'Not enough miles. Please remove some items.': [
        null,
        'Nicht genügend Meilen. Bitte entfernen Sie einige Artikel.',
      ],
      'Not enough miles available for immediate order': [
        null,
        'Nicht genügend Meilen für eine sofortige Bestellung',
      ],
      'Place order': [null, 'Befehl'],
      Confirm: [null, 'Bestätigen'],
      'Empty Cart': [null, 'Warenkorb leeren'],
      'Please select colors and/or size': [
        null,
        'Bitte wählen Sie Farbe(n) und/oder Größe',
      ],
      'Dematerialized product': [null, 'Dematerialisiertes Produkt'],
      Message: [null, 'Nachricht'],
      MILES: [null, 'MILES'],
    },
  },
};
